<script lang="ts" setup>
defineProps<{
  fontClass: string
  title: string
}>()

const PREVIEW_TEXT = 'בְּרֵאשִׁ֖ית בָּרָ֣א אֱלֹהִ֑ים אֵ֥ת הַשָּׁמַ֖יִם וְאֵ֥ת הָאָֽרֶץ׃'
</script>

<template>
  <v-container>
    <v-row dense>
      <v-col justify="end">
        {{ title }}
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <span :class="fontClass" style="font-weight: bold; font-size: 150%">
          {{ PREVIEW_TEXT }}
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>
